module.exports = __webpack_public_path__ + "img/pattern.9bb8b4b2.png";